export enum NotificationStatus {
  Unreaded = 'unreaded',
  Readed = 'readed'
}
